function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { isType } from '../actions/actions';
import { initialPartnersState } from '../../State';
import { SetContactDetailsAction, SetFilterLocationAction } from '../actions/partnersActions';
export default function partnersReducer(state = initialPartnersState, action) {
    if (isType(action, SetFilterLocationAction)) {
        const newState = _object_spread({}, state);
        newState.filterLocation = action.payload;
        return newState;
    } else if (isType(action, SetContactDetailsAction)) {
        const newState = _object_spread({}, state);
        newState.contactDetails = action.payload;
        return newState;
    }
    return state;
}
